<template>
  <div class="page">
    <div class="container">
      <div class="page-contacts">
        <h1 class="title title_red logo_hidden_mob" style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);">UP Communications <br> Agency</h1>

        <div class="map">
          <img src="@/assets/images/map.png" alt="">
          <div class="map__pin"></div>
        </div>

        <form class="contacts-form" @submit.prevent="submit">
          <div class="contacts-form__info">
            <p><a href="tel:+74952408268">+7 (495) 240 82 68</a></p>
            <br>
            <p>117312, Moscow,<br> Prospekt 60-Letiya Oktyabrya, 10A <br> Principal Plaza Business Centre</p>
          </div>

          <div class="contacts-form__actions">
            <div class="contacts-callback" v-if="!sent">
              <div class="contacts-callback__col">
                <input type="email" class="input" placeholder="Email" required v-model="email">
                <input type="text" class="input" placeholder="Name" required v-model="name">
                <textarea class="input input_textarea" placeholder="Question" required v-model="message"/>
              </div>
              <div class="contacts-callback__col">
                <button class="button page__btn" :disabled="sending">send</button>
              </div>
            </div>
            <div class="contacts-callback contacts-callback_success" v-else>Successfully sent!</div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import Axios from 'axios'

export default {
  name: 'contacts-en',
  data () {
    return {
      sending: false,
      sent: false,
      name: '',
      email: '',
      message: ''
    }
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.big-logo', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.contacts-form__info', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.contacts-form__actions', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.map', 0.5, { opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    new TimelineMax()
      .add(TweenMax.to('.map', 0.5, { opacity: 0 }))
      .add(TweenMax.to('.contacts-form__actions', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.contacts-form__info', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.big-logo', 0.3, { y: '30px', opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  },
  methods: {
    submit () {
      if (this.sending) {
        return
      }
      this.sending = true
      Axios.post('/contact.php', {
        name: this.name,
        email: this.email,
        message: this.message
      })
        .then((response) => {
          console.log(response)
          this.sent = true
          setTimeout(() => {
            this.reset()
            this.sent = false
          }, 3000)
        })
        .catch((error) => {
          console.log(error)
          this.sent = true
          setTimeout(() => {
            this.sent = false
          }, 3000)
        })
        .finally(() => {
          this.sending = false
        })
    },
    reset () {
      this.name = ''
      this.email = ''
      this.message = ''
    }
  }
}
</script>
